import withdrawalUpdateSubscriptionGQL from "@/public/graphQl/subscriptions/withdrawalUpdateSubscription";
import { apiClient } from "@/public/graphQl/apiClient";

export const withdrawalUpdateSubscription = async ({ state, commit, rootGetters }) => {
    const client = apiClient;

    const organizationId = rootGetters['app/getSelectedOrganization'].id;

    if (state.withdrawalUpdatedSubClient) {
        state.withdrawalUpdatedSubClient.unsubscribe();
    }

    const sub$ = await client.subscribe({
        query: withdrawalUpdateSubscriptionGQL,
        variables: {
            organizationId
        }
    })

    const updatesSub = sub$.subscribe({
        next: ({ data: { withdrawalUpdate  } }) => {
            commit('setWithdrawalUpdated', withdrawalUpdate);
        }
    });

    commit('setWithdrawalUpdatedSubClient', updatesSub);

    // setTimeout(() => {
    //     commit('setWithdrawalUpdated', {
    //         "id":"5f493fee-7ea1-4baf-be7a-35a2a64d23e8",
    //         "tx":"0x03816577fd7ca49433486d06f481c937613e30d0e4239151c6e8b90576093468",
    //         "status":"error"
    //     });
    //
    // }, 2500)
}
